import React from 'react';
import { useLocation } from 'react-router-dom';
import { background_onboarding, logo } from '../../constants/icons';

const PlayerMandateSuccess = () => {
  const location = useLocation();
  const { agentName } = location.state || {};

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center p-4"
      style={{
        backgroundImage: `url(${background_onboarding})`,
      }}
    >
      <div className="bg-white p-8 w-full max-w-[544px] flex flex-col rounded-xl gap-6 items-center text-center">
        <img src={logo} alt="Transfer Pitch" className="h-10 mb-2 mx-auto" />
        <div className="flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-4">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#16A34A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <div>
          <div className="text-[#1A212F] text-2xl font-bold mb-4">
            Congratulations!
          </div>
          <div className="text-[#1A212F] text-base mb-6">
            You are now being managed by <span className="font-semibold text-[#2283FF]">{agentName || 'your agent'}</span>.
            Your representation agreement is now active.
          </div>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-lg p-4 w-full text-left">
          <div className="flex items-center gap-2 mb-2">
            <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span className="font-medium text-green-800">What happens next?</span>
          </div>
          <ul className="text-sm text-green-700 space-y-1">
            <li>• Your agent will be in touch regarding opportunities</li>
            <li>• You can track your career progress through the platform</li>
            <li>• All transfer activities will be managed professionally</li>
          </ul>
        </div>

        <div className="w-full space-y-3">
          {/* No close button: the page is opened from a mail link, so
              window.close() is refused by the browser. The line below already
              said the truth, so it carries the page on its own. */}
          <p className="text-sm text-gray-500">
            You can close this window. Your agent will contact you with next steps.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlayerMandateSuccess;